/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'edit': {
    width: 19,
    height: 19,
    viewBox: '0 0 19 19',
    data: '<path pid="0" _fill="#203F6A" fill-rule="evenodd" _stroke="#203F6A" stroke-width=".5" d="M15.828 18H2.78A1.78 1.78 0 011 16.22V3.173c0-.982.797-1.78 1.78-1.78h8.303a.593.593 0 110 1.187H2.78a.593.593 0 00-.593.593v13.049a.594.594 0 00.593.593h13.049a.594.594 0 00.593-.593V7.917a.593.593 0 111.186 0v8.304A1.78 1.78 0 0115.828 18zM5.745 13.848a.593.593 0 01-.421-.172.593.593 0 01-.172-.54l.652-3.167a.59.59 0 01.16-.302l7.984-7.972a2.374 2.374 0 013.357 3.357l-7.972 7.972a.616.616 0 01-.302.16l-3.168.664h-.118zm1.186-3.47l-.433 2.112 2.124-.421 7.84-7.853a1.187 1.187 0 00-1.678-1.679l-7.853 7.841z"/>'
  }
})
